import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=059cf3f0&"
import script from "./Gantt.vue?vue&type=script&lang=js&"
export * from "./Gantt.vue?vue&type=script&lang=js&"
import style0 from "./Gantt.vue?vue&type=style&index=0&id=059cf3f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports